import React from "react";
/* eslint-disable import/no-webpack-loader-syntax */
import Vector1 from "-!svg-react-loader!../images/hand_icon.svg";
import Vector2 from "-!svg-react-loader!../images/marketing_vector_2.svg";
import Vector3 from "-!svg-react-loader!../images/marketing_vector_3.svg";
import VideoImage1 from "../images/Rectangle_50.jpg";
import VideoImage2 from "../images/Rectangle 50.jpg";

import Ellipse from "-!svg-react-loader!../images/Ellipse_5.svg";
import Ellipse2 from "-!svg-react-loader!../images/Ellipse_6.svg";
import Polygon from "-!svg-react-loader!../images/Polygon_3.svg";

export default class FrameBuilderBottom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoClicked: false,
      video2Clicked: false
    };
  }

  render() {
    return (
      <div className='framebuilder_bottom'>
        <h1 className='framebuilder__title'>Our materials and process</h1>

        <div className='marketing_icons_section'>
          <div className='icon_div'>
            <Vector1 className='icon' />
            <p>
              Our frames are <span>100% handcrafted</span> by professional
              carpenters based on your specific requirements.
            </p>
          </div>
          <div className='icon_div'>
            <Vector2 className='icon' />
            <p>
              We use <span>high quality wood</span> profiles sourced from Asia &
              Europe, and all of our mat boards are<span> acid free.</span>
            </p>
          </div>
          <div className='icon_div'>
            <Vector3 className='icon' />
            <p>
              <span> We only use acrylic</span> for covering your items. It is
              lighter and safer than glass with exceptional clarity maintained.
            </p>
          </div>
        </div>
        <div className='main_marketing_area'>
          <div className='marketing_section'>
            {!this.state.videoClicked && (
              <div
                className='image_area'
                onClick={e => {
                  e.preventDefault();
                  let el = document.getElementById("player");
                  el.src += "?autoplay=1";
                  this.setState({ videoClicked: true });
                }}
              >
                <div className='icon_area'>
                  <Ellipse className='vid_icon' />
                  <Ellipse2 className='vid_icon' />
                  <Polygon className='vid_icon' />
                </div>
                <img src={VideoImage1} alt='' />
              </div>
            )}

            <div
              className='video_area'
              style={{
                display: this.state.videoClicked ? "block" : "none"
              }}
            >
              <iframe
                className='builder_video'
                allowfullscreen='allowfullscreen'
                mozallowfullscreen='mozallowfullscreen'
                msallowfullscreen='msallowfullscreen'
                oallowfullscreen='oallowfullscreen'
                webkitallowfullscreen='webkitallowfullscreen'
                id='player'
                ref={this.youtube}
                src='https://www.youtube.com/embed/SY64OT0FDE4'
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture allowfullscreen'
              ></iframe>
            </div>
            <div className='square_1'></div>
          </div>

          <div className='text_area'>
            <h1>What is a mat border?</h1>
            <p>
              The mat border is effectively made up of a thick, flat piece of
              paper-based material which sits between the acrylic and your
              framed item. <br />
              <br /> It helps to protect your item from direct contact with the
              acrylic, as well as providing additional aesthetic benefits.
              <br />
              <br /> All of our mat boards are acid-free. Please watch our video
              to find out more.
            </p>
          </div>
        </div>
        <div className='main_marketing_area reverse'>
          <div>
            {!this.state.video2Clicked && (
              <div
                className='image_area'
                onClick={e => {
                  e.preventDefault();
                  let el = document.getElementById("player1");
                  el.src += "?autoplay=1";
                  this.setState({ video2Clicked: true });
                }}
              >
                <div className='icon_area'>
                  <Ellipse className='vid_icon' />
                  <Ellipse2 className='vid_icon' />
                  <Polygon className='vid_icon' />
                </div>
                <img src={VideoImage2} alt='' />
              </div>
            )}

            <div
              className='video_area'
              style={{
                display: this.state.video2Clicked ? "block" : "none"
              }}
            >
              <iframe
                className='builder_video'
                allowfullscreen='allowfullscreen'
                mozallowfullscreen='mozallowfullscreen'
                msallowfullscreen='msallowfullscreen'
                oallowfullscreen='oallowfullscreen'
                webkitallowfullscreen='webkitallowfullscreen'
                id='player1'
                ref={this.youtube}
                src='https://www.youtube.com/embed/5cG0Mni9Oi4'
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture allowfullscreen'
              ></iframe>
            </div>
            <div className='square_1'></div>
          </div>

          <div className='text_area'>
            <h1>Mounting your artwork</h1>
            <p>
              Once your frame arrives, you’ll need to mount your item inside. We
              provide all the necessary materials and instructions to make this
              nice and easy.
              <br /> <br />
              Depending on the size of your item we ship slightly different
              materials. You can check out our{" "}
              <a
                href='https://blog.frameit.com.sg/how-to/mounting-item-inside-frame/'
                className='gold'
                target='_blank'
              >
                full guide here
              </a>
              , or watch our video.
            </p>
          </div>
        </div>
        {/* <div className='main_marketing_area'>
          <div>
            {!this.state.videoClicked && (
              <div
                className='image_area'
                onClick={e => {
                  e.preventDefault();
                  let el = document.getElementById("player");
                  el.src += "?autoplay=1";
                  this.setState({ videoClicked: true });
                }}
              >
                <div className='icon_area'>
                  <Ellipse className='vid_icon' />
                  <Ellipse2 className='vid_icon' />
                  <Polygon className='vid_icon' />
                </div>
                <img src={VideoImage1} alt='' />
              </div>
            )}

            <div
              className='video_area'
              style={{
                display: this.state.videoClicked ? "block" : "none"
              }}
            >
              <iframe
                className='builder_video'
                allowfullscreen='allowfullscreen'
                mozallowfullscreen='mozallowfullscreen'
                msallowfullscreen='msallowfullscreen'
                oallowfullscreen='oallowfullscreen'
                webkitallowfullscreen='webkitallowfullscreen'
                id='player'
                ref={this.youtube}
                src='https://www.youtube.com/embed/SY64OT0FDE4'
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture allowfullscreen'
              ></iframe>
            </div>
            <div className='square_1 square_3'></div>
          </div>

          <div className='text_area'>
            <h1>Which acrylic to choose?</h1>
            <p>
              Our standard acrylic will be perfect for most framing situations,
              but should you be hanging an item in direct sunlight, or just
              prefer some additional peace of mind, you may wish to consider our
              Enhanced UV Protect acrylic.
              <br />
              <br />
              This is a high quality Acrylic from Evonik Plexiglass that
              provides up to 99% UV filtration. Don’t hesitate to get in touch
              if you would any additional information.
            </p>
          </div>
        </div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FrameBuilderBottom.js